import { Enumify } from "enumify-ts";
class EmployeeDriverLicenseCompliance extends Enumify() {
    description;
    static NONE = new EmployeeDriverLicenseCompliance("None");
    static OPTIONAL = new EmployeeDriverLicenseCompliance("Optional");
    static MANDATORY = new EmployeeDriverLicenseCompliance("Mandatory");
    static _ = EmployeeDriverLicenseCompliance._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return EmployeeDriverLicenseCompliance.values.map(r => {
            return {
                label: r.description,
                value: r.key
            };
        });
    }
}
export default EmployeeDriverLicenseCompliance;
